module.exports = __webpack_public_path__ + "img/pro-active.57fef741.png";